// removed by extract-text-webpack-plugin
module.exports = {"label":"_3H9eA","radio":"_1NndF","fakeRadioChecked":"_4pWoS","fakeRadio":"_16kV9","innerCircleWrapper":"_2OA4_","innerCircle":"_3aco1","text":"_1qunH"};


//////////////////
// WEBPACK FOOTER
// ./app/components/input-radio/input-radio.scss
// module id = 868
// module chunks = 3 4 5 6 7